import queryString from "query-string";

import {
    CREATE_IDP_PERIOD,
    GET_IDP_PERIOD,
    UPDATE_IDP_PERIOD
} from "@/api/settings/idpPeriod";

const state = {
    idpPeriod: [],
    createIdpPeriod:[],
    updateIdpPeriod:[],
};

const mutations = {
    setIdpPeriod: (states, payload) => {
        states.idpPeriod = payload;
    },
    createIdpPeriod: (states, payload) => {
        states.createIdpPeriod = payload;
    },
    updateIdpPeriod: (states, payload) => {
        states.createIdpPeriod = payload;
    },
};

const actions = {
    getIdpPeriod: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IDP_PERIOD(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpPeriod", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpPeriod", []);
            }
            throw err;
        }
    },
    createIdpPeriod: async ({ commit }, args) => {
        try {
            const resp = await CREATE_IDP_PERIOD(args);
            if (resp.data.httpCode === 200) {
                commit("createIdpPeriod", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("createIdpPeriod", []);
            }
            throw err;
        }
    },
    updateIdpPeriod: async ({ commit }, args) => {
        try {
            const resp = await UPDATE_IDP_PERIOD(args);
            if (resp.data.httpCode === 200) {
                commit("updateIdpPeriod", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("updateIdpPeriod", []);
            }
            throw err;
        }
    },
};

const getters = {
    IdpPeriod: (states) => states.idpPeriod,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};